import {_BASIC_TRANSACTIONS ,TOGGLE_STEPS_LIST, SELECT_STEP} from '../../actions/types'

const initialState = {
    selection: 0,
    isOpen: false,
}

// eslint-disable-next-line
export default function(state = initialState, action) {
    if(action.feature === _BASIC_TRANSACTIONS) {
        switch(action.type) {
            case TOGGLE_STEPS_LIST:
                return { ...state, isOpen: !state.isOpen }
            case SELECT_STEP:
                return { ...state, selection: action.payload, isOpen: false }
            
            default:
                return state
        }
    }
    else {
        return state
    }
}